import './assets/main.scss'
import { applyPlatformPresentation } from '@/composables/usePlatform'

applyPlatformPresentation()

import {createApp, nextTick} from 'vue'
import {createPinia} from 'pinia'

import App from './App.vue'
import router from './router'
import { useUserStore } from './stores/user'
import { initializePushNotifications } from './services/push'
import { initAppUpdater } from './services/appUpdater'
import { initializeSessionRecovery } from './services/sessionRecovery'
import i18n from './i18n';
import VCalendar from 'v-calendar';

const app = createApp(App)

app.use(createPinia())
initializeSessionRecovery(router, useUserStore())
app.use(router)
app.use(i18n)
app.use(VCalendar, {})
initializePushNotifications(router, useUserStore())

app.mount('#app')
void nextTick().then(initAppUpdater)
